import './index.scss';



/** WEBPACK FOOTER **
 ** ./src/NoticeList/index.js
 **/